/**
 * Platform roles, as string constants (plan D-E / D-P). All three are
 * Roommatik staff only — there is no external/hotel role in this
 * application. Never rename these values; they are the contract between
 * the access provider and every route guard.
 *
 * The three are a ladder of blast radius, not of seniority:
 * `platform:auditor` reads, `platform:admin` also writes the day-to-day
 * configuration (tenants, payment policies, applications, test bench), and
 * `platform:superadmin` additionally performs the writes that mint, replace
 * or narrow access itself — gateway credentials, the gateway account that
 * decides which provider and which mode a hotel's money moves through, and
 * the whole API-credential lifecycle. The API enforces exactly this split;
 * this constant exists so the console can hide what the API would refuse
 * instead of offering a button that returns 403.
 */
export const PlatformRole = {
  SuperAdmin: 'platform:superadmin',
  Admin: 'platform:admin',
  Auditor: 'platform:auditor',
} as const;

export type PlatformRole = (typeof PlatformRole)[keyof typeof PlatformRole];

const ALL_ROLES: readonly string[] = Object.values(PlatformRole);

export function isPlatformRole(value: string): value is PlatformRole {
  return ALL_ROLES.includes(value);
}
